import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';
import { useTranslate } from '~/shared/context/use-translate';
import { Button } from '~/ui/core/button/Button';
import { IconExternalLink } from '~/ui/core/icons';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import type { LearningOpportunity } from '../data-contract';

export const TakeCourseButton: FunctionComponent<{ readonly learningOpportunity: LearningOpportunity }> = ({
    learningOpportunity,
}) => {
    const translate = useTranslate();
    const {
        actions: { openWindow },
    } = useApplicationContext();
    const { sendTrackingEvent } = useApplicationFetchers();

    const takeCourse = (): void => {
        sendTrackingEvent({
            name: 'learning-opportunity-taken',
            payload: { provider: learningOpportunity.provider ?? 'unknown' },
        });
        if (is.nonEmptyString(learningOpportunity.url)) openWindow(learningOpportunity.url);
    };

    return (
        <Button
            disabled={!is.nonEmptyString(learningOpportunity.url)}
            iconPosition="leading"
            size="sm"
            variant="secondary"
            onClick={takeCourse}
        >
            <IconExternalLink size={14} />
            {translate('components.take-course')}
        </Button>
    );
};
